import React from 'react';
import clsx from 'clsx';
import { useAuth } from '@/context/Authentication';
import { Tooltip, useTooltip, useUi } from '@/context/Ui';
import { PhonicsLogo, Button } from '@/components';

const StudentContainer = ({
  children,
  className,
}: React.PropsWithChildren<{
  className?: string;
}>) => (
  <div className={clsx('container mx-auto px-6', className)}>{children}</div>
);

interface StudentLayoutProps {
  className?: string;
}

export const StudentLayout = ({
  children,
  className,
}: React.PropsWithChildren<StudentLayoutProps>) => {
  const { user } = useAuth();
  const { tooltipRef } = useTooltip();
  const { bgColor } = useUi();

  return (
    <>
      <div
        className={clsx(
          'relative flex flex-col gap-12 h-screen min-w-96 overflow-auto',
          bgColor === 'sky' && 'bg-pt-jey-sky',
          bgColor === 'grass' && 'bg-pt-green-grass',
          bgColor === 'grass' &&
            'before:bg-hills before:bg-bottom before:bg-no-repeat',
          bgColor === 'grass' &&
            'before:z-2 before:absolute before:top-0 before:left-0',
          bgColor === 'grass' &&
            'before:bg-pt-jey-sky before:w-full before:h-96 ',
          bgColor === 'grass' &&
            'after:bg-trees after:absolute after:left-1/2 after:top-44',
          bgColor === 'grass' && 'after:-translate-x-[22.6rem]',
          bgColor === 'grass' && 'after:w-[145px] after:h-[145px]',
          className,
        )}
      >
        <header className="mt-6 relative z-3">
          <StudentContainer className="flex justify-center">
            <PhonicsLogo className="max-w-[498px] min-w-48" />
          </StudentContainer>
        </header>

        <main className={clsx(bgColor === 'grass' && 'mt-48')}>
          <StudentContainer>{children}</StudentContainer>
        </main>

        <footer>
          <StudentContainer className="flex justify-center">
            {user && (
              <Button href="/logout" ignoreRouter>
                Logout
              </Button>
            )}
          </StudentContainer>
        </footer>
      </div>

      <Tooltip ref={tooltipRef} />
    </>
  );
};
